import { Injectable } from '@angular/core';
import { catchAndContinue, filterUndefined } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { Visitation } from 'src/app/models';
import { SharePointService } from 'src/app/services';
import { EquipmentFacadeService } from 'src/app/services/equipment-facade.service';
import { handleError } from 'src/app/state/akita-error-helper';
import { CollectionState } from 'src/app/state/collection-state';

@Injectable({ providedIn: 'root' })
export class VisitationService {
  private readonly state = new CollectionState<Visitation>();

  public readonly visitations$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(
    private readonly sharePointDataService: SharePointService,
    private readonly equipmentFacade: EquipmentFacadeService
  ) {}

  public loadByActiveEquipmentNumber(): Observable<Visitation[]> {
    return this.equipmentFacade.selectedEquipmentId$.pipe(
      filterUndefined(),
      switchMap((equipmentNumber) =>
        catchAndContinue(
          this.sharePointDataService.getVisitationDocumentByEquipmentNumber(equipmentNumber),
          (error) => {
            handleError(this.state, error);
          }
        )
      ),
      tap((visitations: Visitation[]) => {
        this.state.set(visitations);
      })
    );
  }
}
